import { styled } from '@mui/material/styles'
import { PickersDay } from '@mui/x-date-pickers/PickersDay'
import { blue, common } from '@mui/material/colors'
import { HEATMAP_VALUE_TO_RECURRENCE, RECURRENCE_TO_HEATMAP_VALUE, WORK_ORDER_STATUS_COLORS } from 'settings/constants/workOrder'

// Grid layout constants
export const GRID_COLUMN_WIDTH = '33.33%'
export const GRID_COLUMN_WIDTH_LAST = '33.34%'
export const ICON_ROW_HEIGHT_3 = '33.33%'
export const ICON_ROW_HEIGHT_4 = '25%'
export const ICON_ROW_HEIGHT_5 = '20%'

/**
 * Styled PickersDay component with heatmap and status-based styling
 */
export const StyledPickersDay = styled(PickersDay)(
  ({ theme, heatmapValue, isInRange, isRangeStart, isRangeEnd, workOrderStatus, hasMultipleStatusTypes }) => {
    const heatmapData = HEATMAP_VALUE_TO_RECURRENCE[heatmapValue]

    let backgroundColor = 'transparent'
    if (hasMultipleStatusTypes) {
      backgroundColor = common.white
    } else if (workOrderStatus && WORK_ORDER_STATUS_COLORS[workOrderStatus]) {
      backgroundColor = WORK_ORDER_STATUS_COLORS[workOrderStatus]
    }

    const isEmpty = heatmapValue === RECURRENCE_TO_HEATMAP_VALUE.EMPTY && !workOrderStatus

    const getHoverBackgroundColor = () => {
      if (isRangeStart || isRangeEnd) return blue[800]
      if (heatmapData) return heatmapData.color
      return theme.palette.action.hover
    }

    return {
      backgroundColor,
      borderRadius: '8px',
      width: '100%',
      height: 'auto',
      aspectRatio: '1 / 1',
      border: isEmpty ? 'none' : '1px solid',
      margin: '0',
      borderColor: isEmpty ? 'transparent' : theme.palette.divider,
      '&:hover': {
        backgroundColor: getHoverBackgroundColor(),
        opacity: 0.9,
      },
      '&.Mui-selected': {
        backgroundColor: blue[500],
        '&:hover': {
          backgroundColor: blue[200],
        },
      },
      ...(isInRange && {
        borderTop: '2px dashed',
        borderBottom: '2px dashed',
        borderLeft: 'none',
        borderRight: 'none',
        borderTopColor: blue[500],
        borderBottomColor: blue[500],
        borderRadius: 0,
        backgroundColor: blue[50],
      }),
      ...(isRangeStart && {
        borderRightWidth: '0',
        borderStyle: 'solid',
        borderBottomColor: blue[500],
        borderTopColor: blue[500],
        borderLeftColor: blue[500],
        borderTopLeftRadius: '16px',
        borderBottomLeftRadius: '16px',
        backgroundColor: blue[500],
        color: common.white,
      }),
      ...(isRangeEnd && {
        borderLeftWidth: '0',
        borderStyle: 'solid',
        borderTopColor: blue[500],
        borderBottomColor: blue[500],
        borderRightColor: blue[500],
        borderTopRightRadius: '16px',
        borderBottomRightRadius: '16px',
        backgroundColor: blue[500],
        color: common.white,
      }),
    }
  }
)

/**
 * Column container styles for the calendar day grid
 */
export const columnContainerStyles = (left, width = GRID_COLUMN_WIDTH) => ({
  position: 'absolute',
  top: 0,
  left,
  width,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  pointerEvents: 'none',
})

/**
 * Icon row styles
 */
export const iconRowStyles = height => ({
  height,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})
